import { useTranslation } from "react-i18next";
import { useDepartments, useGetCemVersions } from "src/hooks/useDepartments";
import { useTerms } from "src/hooks/useTerms";

import { useQueryState } from "../../../hooks/useQueryState";
import { useGetExamPreviewDetails } from "../../../hooks/useQuestions";
import DefaultCreator from "./DefaultCreator";
import FiltersContainer from "./Filters/ExamFilters";

const defaultState = {
	departments: [],
	tags: [],
	subtags: [],
	terms: [],
	consultants: [],
	cemVersions: [],
	level: [],
	typeOfExam: null,
	additionalOption: {
		starred: false,
		wrongAnswers: false,
		skipCanceledQuestions: false,
		isNote: false,
		isUnanswered: false,
	},
};

export default function DefaultExamCreator(props) {
	const initialState = {
		...defaultState,
		...(props.disabledShuffle
			? {}
			: {
					shuffle: {
						checked: false,
						questions: 1,
					},
				}),
		...(props.extraInitialState ? props.extraInitialState : {}),
	};
	const { t } = useTranslation();
	const { isLoading: isTermsLoading, data: terms } = useTerms();
	const { isLoading: isCemVersionLoading, data: cemVersions } =
		useGetCemVersions();
	const { isLoading: isDepartmentsLoading, data: departments } =
		useDepartments();
	const [examDetails, setExamDetails] = useQueryState(initialState);
	const { data: { count, name, examCount, examTime } = {}, isLoading } =
		useGetExamPreviewDetails(examDetails);

	const renderFilters = () => {
		return (
			<FiltersContainer
				count={count}
				examDetails={examDetails}
				setData={setExamDetails}
				departments={departments}
				terms={terms}
				cemVersions={cemVersions}
				isLoading={
					isTermsLoading || isDepartmentsLoading || isCemVersionLoading
				}
				renderExtraFilters={() => {
					if (props.renderExtraFilters) {
						return props.renderExtraFilters(examDetails, setExamDetails, {
							count: count,
						});
					}
				}}
				renderExtraFiltersBefore={() => {
					if (props.renderExtraFiltersBefore) {
						return props.renderExtraFiltersBefore(examDetails, setExamDetails, {
							examTime,
						});
					}
				}}
			/>
		);
	};

	const getCount = () => {
		return examCount;
	};

	const onSubmit = async (name, folderIds) => {
		await props.onSubmit(examDetails, name, getCount(), folderIds);
	};
	const isDisabled = () => {
		const disabled = props.isDisabled ? props.isDisabled(examDetails) : false;

		return disabled || count === 0;
	};

	return (
		<DefaultCreator
			count={getCount()}
			countLoading={isLoading}
			onSubmit={onSubmit}
			renderFilters={renderFilters}
			Header={props.Header}
			inputPlaceholder={props.inputPlaceholder}
			counterText={t("creators.exams.counterText")}
			defaultName={name}
			isLoading={props.isLoading || isLoading}
			reset={() => setExamDetails(defaultState)}
			disabled={isDisabled()}
			initialSelectedFolderIds={props.initialSelectedFolderIds}
		/>
	);
}
